import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  TitleComtainer,
  DetailContainer
} from './style';
import unit_institution from "../../../store/asset_institution/unit_institution";
import unit_institution_chuzhi from "../../../store/asset_institution/unit_institution_chuzhi";
import { webviewRedirect } from '../../../utils/tool';
import { format } from 'date-fns';

class ChuzhiNoticeItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  gotoItemPage(id) {
    const {setTabIndex} = unit_institution;
    const {setChuzhiNoticeListData} = unit_institution_chuzhi;
    setChuzhiNoticeListData();
    setTabIndex();
    webviewRedirect(`//mpaimai.jd.com/newNoticeDetail/${id}?path=newNoticeDetail&type=chuzhi`)
  }

  render() {
    const {id, title, publishTime} = this.props.itemInfo;
    return (
      <ItemContainer onClick={() => {
        this.gotoItemPage(id);
      }}>
        <TitleComtainer>{title}</TitleComtainer>
        {
          !!publishTime && (
            <DetailContainer>发布时间：{format(Number(publishTime), "YYYY年MM月DD日")}</DetailContainer>
          )
        }
      </ItemContainer>
    )
  }
}

export default ChuzhiNoticeItem;
